import { useEffect } from 'react';
import './Reports.scss';
import { useDispatch } from "react-redux";
import { Typography, Collapse, Image } from 'antd';
import ReportsCollapseContent from './ReportsCollapseContent';
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg"
import { getReportDropdowns } from '../../redux/slices/ReportsSlice';

const { Title } = Typography;

const Reports = () => {
  const dispatch = useDispatch();

  const panelStyle = {
    marginBottom: 10,
    border: "none",
  };

  useEffect(() => {
    dispatch(getReportDropdowns());
  }, [dispatch]);

  const collapseItems = (panelStyle) => [
    {
      key: "1",
      label: "Deal wise Settlement",
      children: <ReportsCollapseContent type="1" title="Deal wise Settlement" />,
      style: panelStyle,
    },
    {
      key: "2",
      label: "Business Ledger",
      children: <ReportsCollapseContent type="2" title="Business Ledger" />,
      style: panelStyle,
    },
  ];

  return (
    <div className='reports-container'>
      <Title level={4}>Download Reports</Title>
      <div className='reports-details-container'>
        <Collapse
          bordered={false}
          items={collapseItems(panelStyle)}
          expandIconPosition="end"
          expandIcon={({ isActive }) => (
            <Image
              src={ArrowDownIcon}
              alt='Arrow'
              preview={false}
              style={{
                transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease'
              }}
            />
          )}
          style={{ background: "#ffffff", width: "100%" }}
        />
      </div>
    </div>
  );
}

export default Reports;
